import React, { createContext, useContext, useState, useCallback } from 'react';
import KmlToShapefileDialog from '@/ui/tools/KmlToShapefileDialog';

type KmlDialogContextValue = {
  open: boolean;
  openDialog: () => void;
  closeDialog: () => void;
};

const KmlDialogContext = createContext<KmlDialogContextValue | null>(null);

export function KmlDialogProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);
  const openDialog = useCallback(() => setOpen(true), []);
  const closeDialog = useCallback(() => setOpen(false), []);
  return (
    <KmlDialogContext.Provider value={{ open, openDialog, closeDialog }}>
      {children}
      <KmlToShapefileDialog />
    </KmlDialogContext.Provider>
  );
}

export function useKmlDialog() {
  const ctx = useContext(KmlDialogContext);
  if (!ctx) {
    return { open: false, openDialog: () => {}, closeDialog: () => {} };
  }
  return ctx;
}
